import React, {Fragment, useEffect, useRef, useState} from "react"
import styles from "../../../styles/viewing.module.css";
import DatePicker from "react-datepicker";
import {formatDateToISO, timeConverter, viewingSlots} from "../../../utils/helpers";
import {GiWorld} from "react-icons/gi"
import {Form} from "react-bootstrap";
import getDay from "date-fns/getDay";
import UnitViewingService from "../../../services/unit-viewing.service";
import UnitListingService from "../../../services/unit-listing.service";
import useForm from "../../../hooks/use-form";
import {USER_UNIT_FILTER} from "../../../utils/constants/listing";
import DefaultLoader from "../../common/loaders/default-loader";

const fields = {
    unit:"",
    applicant:"",
    timezone:"",

}
let days = {mon:1,tue:2,wed:3,thu:4,fri:5,sat:6,sun:0}

const ScheduleViewing = ({submitHandler,unitId,renterId}) => {
    const {useFetchUnitAvailabilities,useFetchTimezones} = UnitViewingService()
    const {useFetchUserListing,useFetchListingApplicants} = UnitListingService()
    const {inputEvent,details} = useForm(fields)

    const {data: unitData,isLoading: isUnitLoading} = useFetchUserListing(unitId ? '' : USER_UNIT_FILTER.NEWEST,1, "",99)

    let dayKeys = Object.keys(days)
    const [startDate,setStartDate] = useState(null)
    const [filteredDays,setFilteredDays] = useState([])
    const [slot,setSelectedSlot] = useState(null)
    const [slotList,setSlotList] = useState([])
    const [filteredAvailability,setFilteredAvailability] = useState({})

    const {data:availabilityData,isFetching: isAvailabilityLoading,isSuccess: isAvailabilitySuccess} = useFetchUnitAvailabilities(unitId ? unitId : details?.unit)
    const {data: applicantsData, isFetching: isApplicantsDataLoading} = useFetchListingApplicants('',1,99,!renterId ? unitId ? unitId : details?.unit : '')
    const {data:timezones, isLoading:isTimezonesLoading} = useFetchTimezones()

    useEffect(()=>{
        if(isAvailabilitySuccess){
            let filteredApiData = availabilityData

            let {mon,tue,wed,thu,fri,sat,sun} = filteredApiData
            filteredApiData = {mon,tue,wed,thu,fri,sat,sun}

            dayKeys.forEach(key => {
                if(!filteredApiData[key]?.length > 0){
                    setFilteredDays(prev => [...prev,days[key]])
                }else{
                    setFilteredAvailability(prev => ({
                        ...prev,
                        [key]:filteredApiData[key]
                    }))
                }
            })
        }
    },[isAvailabilitySuccess])

    //When date is selected on the datepicker, populate the slots array
    useEffect(()=>{
        if(!!startDate){
            const daysByNumber = [1,2,3,4,5,6,0]
            const activeDays = daysByNumber.filter(el => !filteredDays.includes(el))
            let slots = []
            dayKeys.forEach(key => {
                if(activeDays.includes(days[key])){
                    if(new Date(startDate).getDay() === days[key]){
                        console.log(filteredAvailability,"filteredAvailability")
                        for (let i = 0; i < filteredAvailability[key]?.length; i++) {
                            slots.push(...viewingSlots(filteredAvailability[key][i]?.startTime,filteredAvailability[key][i]?.endTime,availabilityData?.duration,startDate))
                        }

                        // console.log(filteredAvailability[key],"filteredAvailability[key]")
                        // console.log(availabilityData,"availabilityData")
                        // console.log(slots,"slots")
                        setSlotList(slots)
                    }
                }
            })
        }
    },[startDate])

    const isActiveDay = (date) => {
        const day = getDay(date);
        return !filteredDays.includes(day)
    };
    const onUnitChange = (e) =>{
        setStartDate(null)
        setSlotList([])
        setSelectedSlot(null)
        inputEvent(e)
    }

    const dataRef = useRef(false)

    useEffect(()=>{
        if(dataRef){
            submitHandler({
                timezone:details?.timezone,
                startDateTime:`${formatDateToISO(startDate ? new Date(startDate) : new Date())}T${slot?.startTime}:00.000Z`,
                endDateTime:`${formatDateToISO(startDate ? new Date(startDate) : new Date())}T${slot?.endTime}:00.000Z`,
            }, renterId ? renterId : details?.applicant, unitId ? unitId : details?.unit)
        }
        dataRef.current = true
    },[details?.unit,details?.applicant,details?.timezone,slot,startDate,unitId,renterId])

    if (isTimezonesLoading || isApplicantsDataLoading || isAvailabilityLoading || isUnitLoading) return <DefaultLoader/>
    return(
        <>
            <div className={styles.availability__selection__wrapper}>
                {availabilityData && <div className={'scheduler__datepicker'}>
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        filterDate={isActiveDay}
                        inline
                    />
                    <div className={styles.timezones__wrapper}>
                        <div className={styles.timezone}>
                            <GiWorld/>
                            <Form.Select
                                name={"timezone"}
                                onChange={inputEvent}
                                value={details.timezone}
                            >
                                <option value={''} disabled>Select A Timezone</option>
                                {timezones?.length > 0 && timezones?.map((timezone)=>{
                                    return(
                                        <Fragment key={timezone?.timezone}>
                                            <option value={timezone?.timezone}>{timezone?.label}</option>
                                        </Fragment>
                                    )
                                })}
                            </Form.Select>
                        </div>

                    </div>
                </div>}
                {(startDate && availabilityData) && <div className={styles.availability__selection}>
                    <p>{new Date(startDate).toDateString()}</p>
                    <div className={styles.btn__wrapper}>
                        {slotList?.map(el => (
                            <Fragment key={el?.startTime}>
                                <button onClick={() => setSelectedSlot(el)} className={slot?.startTime === el?.startTime ? styles.active : ''}>
                                    {el?.startTime}
                                </button>
                            </Fragment>
                        ))}
                    </div>
                </div>}
            </div>
            <div>
                <Form.Group className={styles.form__group__wrapper}>
                    {!unitId && <Form.Group>
                        <label className={`${styles.label} mb-2`}>Units</label>
                        <Form.Select
                            name={"unit"}
                            onChange={onUnitChange}
                            value={details.unit}
                        >
                            <option value={''} disabled>Select A Unit</option>
                            {unitData?.data?.data?.length > 0 && unitData?.data?.data?.map((unit) => {
                                return (
                                    <Fragment key={unit?._id}>
                                        <option value={unit?._id}>{unit?.name}</option>
                                    </Fragment>
                                )
                            })}
                        </Form.Select>
                    </Form.Group>}
                    {((details?.unit || unitId) && !renterId) && <Form.Group>
                        <label className={`${styles.label} mb-2`}>Applicants</label>
                        <Form.Select
                            name={"applicant"}
                            onChange={inputEvent}
                            value={details.applicant}
                        >
                            <option value={''} disabled>Select An Applicant</option>
                            {applicantsData?.data?.length > 0 && applicantsData?.data?.map((applicant)=>{
                                return(
                                    <Fragment key={applicant?._id}>
                                        <option value={applicant?.renter?._id}>{`${applicant?.renter?.firstName} ${applicant?.renter?.lastName}`}</option>
                                    </Fragment>
                                )
                            })}
                        </Form.Select>
                    </Form.Group>}

                </Form.Group>
            </div>
        </>
    )
}
export default ScheduleViewing
